/// <reference types="vite/client" />

declare global {
  interface Window {
    TENANT_API_URL?: string;
    APP_CONFIG?: {
      syncfusionLicenseKey?: string;
      environment?: string;
      onlineBaseUrl?: string;
      recaptchaSiteKey?: string;
    };
  }
}

// Derive the tenant from the first URL path segment: members.fittrack.club/{tenant}/...
const _tenant = window.location.pathname.split('/').filter(Boolean)[0] ?? '';

// Resolve the API base URL.
// Priority:
//   1. window.TENANT_API_URL  — set by /{tenant}/config.js (written by deploy pipeline)
//   2. VITE_API_URL env var   — set in .env.local for local dev against a specific API
//   3. ''                     — falls back to Vite proxy (/api → localhost:5000)
function resolveApiUrl(): string {
  if (window.TENANT_API_URL) return window.TENANT_API_URL;
  const envOverride = import.meta.env.VITE_API_URL as string | undefined;
  if (envOverride) return envOverride;
  return '';
}

// Resolve the FitTrackOnline base URL.
// Priority:
//   1. window.APP_CONFIG.onlineBaseUrl — set explicitly by config.js
//   2. Derived from environment field  — 'prod' → ftonline, 'test' → test-ftonline
//   3. Dev fallback                    — test domain (matches local dev data)
function resolveOnlineBaseUrl(): string {
  if (window.APP_CONFIG?.onlineBaseUrl) return window.APP_CONFIG.onlineBaseUrl;
  const env = window.APP_CONFIG?.environment;
  if (env === 'prod' || env === 'production') return 'https://online.fittrack.club';
  if (env === 'test') return 'https://test-ftonline.fittrack.club';
  return 'https://test-ftonline.fittrack.club';
}

export const config = {
  apiUrl: resolveApiUrl(),
  onlineName: _tenant,
  onlineBaseUrl: resolveOnlineBaseUrl(),
  recaptchaSiteKey: window.APP_CONFIG?.recaptchaSiteKey ?? '',
};
